/**
 * Custom tick component for month segments - displays month and year in two lines
 */
export const MonthYearTick = ({ x, y, payload, fontSize, lineHeight }: { x: string | number; y: string | number; payload: { value: any }; fontSize: number; lineHeight: number }) => {
    const value = payload.value;
    const valueStr = value !== null && value !== undefined ? String(value) : '';

    // Handle "January 2025" format specifically
    const monthYearPattern = /^(\w+)\s+(\d{4})$/;
    const match = valueStr.match(monthYearPattern);
    
    if (match) {
        const month = match[1];
        const year = match[2];
        
        return (
            <g transform={`translate(${x},${y})`}>
                <title>{valueStr}</title>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="middle"
                    fill="#5a717a"
                    fontSize={fontSize}
                    fontFamily="Roboto, sans-serif"
                >
                    {month}
                </text>
                <text
                    x={0}
                    y={0}
                    dy={16 + lineHeight}
                    textAnchor="middle"
                    fill="#5a717a"
                    fontSize={fontSize}
                    fontFamily="Roboto, sans-serif"
                >
                    {year}
                </text>
            </g>
        );
    }

    // Fallback to single line display if it doesn't match the expected format
    return (
        <g transform={`translate(${x},${y})`}>
            <title>{valueStr}</title>
            <text
                x={0}
                y={0}
                dy={16}
                textAnchor="middle"
                fill="#5a717a"
                fontSize={fontSize}
                fontFamily="Roboto, sans-serif"
            >
                {valueStr}
            </text>
        </g>
    );
};
